import React from "react";

import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/styles';
import { compose } from 'redux';

import { Dialog, IconButton } from '@material-ui/core';

import IcClose from "../../../resources/icons/ic_close.js";

import InvestmentsList from "../../../base/user_investments/investments_list.js";

const styles = theme => ({
  root: {
    padding: "32px 0px",
    "& .MuiDialog-paper": {
      width: "100%",
      maxWidth: "85vw",
      padding: "70px 120px",
      borderRadius: "4px",
      ['@media (max-width: 992px)']: {
        padding: "70px 50px",
      },
      ['@media (max-width: 768px)']: {
        padding: "70px 25px",
        maxWidth: "100vw",
        margin: "0px",
        borderRadius: "0px"
      },
    },
    "& .MuiDialog-paperScrollPaper": {
      ['@media (max-width: 768px)']: {
        maxHeight: "100%",
      },
    },
    ['@media (max-width: 768px)']: {
      padding: "0px",
    },
  },
  content: {
    position: "relative"
  },
  titleRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "78px",
    ['@media (max-width: 768px)']: {
      marginBottom: "16px",
    }
  },

  title: {
    color: theme.palette.greenMain,
    fontSize: "45px",
    lineHeight: "50px",
    textTransform: "uppercase",
    textShadow: "0px 2px 6px rgba(0, 0, 0, 0.18)",
    flexGrow: "1",
    ['@media (max-width: 768px)']: {
      fontSize: "18px",
      lineHeight: "26px",
      textShadow: "none"
    }
  },
  close: {
    width: "28px",
    height: "28px",
    flexBasis: "28px",
    flexShrink: "0",
    ['@media (max-width: 768px)']: {
      width: "24px",
      height: "24px",
      top: "0px",
      right: "0px",
      position: "absolute",
    },
  },
});

class ShowAllInvestments extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };

    const { participant, project } = props;
    
    this.project = project;
    this.participant = participant;
  }

  static getDerivedStateFromProps(props, state) {
    return {
      ...state,
      open: props.open
    }
  }
  
  render() {
    const { classes, close } = this.props;

    const { open } = this.state;

    const { name: projectName } = this.project;
    const { investments = [] } = this.participant;

    return <Dialog open = { open } 
                   onClose = { this.onClose }
                   className = { classes.root } >
    <div className = { classes.content }  >
      <div className = { classes.titleRow } >
        <div className = { classes.title } >
          { projectName }
        </div>
        <IconButton className = { classes.close }
                    onClick = { close } >
          <IcClose />
        </IconButton>
      </div>
      <InvestmentsList investments = { investments }
                       withProjectInfo = { false } 
                       onOpenInvestment = { close } />
    </div>
  </Dialog>
  }
}

export default compose(
  withRouter,
  withStyles(styles)
)(ShowAllInvestments);
